import styled from 'styled-components'

export const Title = styled.h4`
  font-size: 17px;
  font-weight: 600;
  line-height: 25.6px;
  margin: 0;
`
